"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var chain_1 = require("popmotion/compositors/chain");

var delay_1 = require("popmotion/compositors/delay");

var flip_1 = require("../dom/flip");

var default_transitions_1 = require("../inc/default-transitions");

var selectors_1 = require("../inc/selectors");

exports.resolveProp = function (target, props) {
  return typeof target === 'function' ? target(props) : target;
};

var poseDefault = function poseDefault(pose, prop, defaultValue, resolveProps) {
  return pose && pose[prop] !== undefined ? exports.resolveProp(pose[prop], resolveProps) : defaultValue;
};

var startChildAnimations = function startChildAnimations(children, next, nextPose, props) {
  var animations = [];
  var delay = poseDefault(nextPose, 'delayChildren', 0, props);
  var stagger = poseDefault(nextPose, 'staggerChildren', 0, props);
  var staggerDirection = poseDefault(nextPose, 'staggerDirection', 1, props);
  var maxStaggerDuration = (children.size - 1) * stagger;
  var generateStaggerDuration = staggerDirection === 1 ? function (i) {
    return i * stagger;
  } : function (i) {
    return maxStaggerDuration - i * stagger;
  };
  Array.from(children).forEach(function (child, i) {
    animations.push(child.set(next, __assign({}, props, {
      delay: delay + generateStaggerDuration(i)
    })));
  });
  return animations;
};

var createPoseSetter = function createPoseSetter(setterProps) {
  return function (next, props) {
    if (props === void 0) {
      props = {};
    }

    var activeActions = setterProps.activeActions,
        activePoses = setterProps.activePoses,
        children = setterProps.children,
        poses = setterProps.poses,
        dimensions = setterProps.dimensions,
        values = setterProps.values,
        types = setterProps.types,
        dragProps = setterProps.dragProps,
        getTransitionProps = setterProps.getTransitionProps,
        flipEnabled = setterProps.flipEnabled;
    var _a = props.delay,
        delay = _a === void 0 ? 0 : _a;
    var dragBounds = dragProps.dragBounds;
    var hasChildren = children.size;
    var nextPose = poses[next];

    var baseTransitionProps = __assign({
      dimensions: dimensions,
      dragBounds: dragBounds
    }, getTransitionProps(), props);

    var getChildAnimations = function getChildAnimations() {
      return hasChildren ? startChildAnimations(children, next, nextPose, baseTransitionProps) : [];
    };

    var getParentAnimations = function getParentAnimations() {
      if (!nextPose) return [];
      if (flipEnabled && flip_1.isFlipPose(nextPose, next)) nextPose = flip_1.flipPose(setterProps, nextPose);
      var getTransition = nextPose.transition;
      return Object.keys(selectors_1.getPoseValues(nextPose)).map(function (key) {
        return new Promise(function (complete) {
          var value = values.get(key);
          var type = types.get(key);
          var from = value.get();

          var transitionProps = __assign({
            key: key,
            type: type,
            from: type ? type.parse(from) : from,
            velocity: value.getVelocity() || 0,
            prevPoseKey: activePoses.get(key)
          }, baseTransitionProps);

          var unparsedTarget = exports.resolveProp(nextPose[key], transitionProps);
          if (activeActions.has(key)) activeActions.get(key).stop();
          var transition = getTransition(__assign({
            to: type ? type.parse(unparsedTarget) : unparsedTarget
          }, transitionProps));
          if (transition === false) transition = default_transitions_1.just(unparsedTarget);
          var poseDelay = exports.resolveProp(nextPose.delay, baseTransitionProps);

          if (delay || poseDelay) {
            transition = chain_1.default(delay_1.default(delay || poseDelay), transition);
          }

          if (type) transition = transition.pipe(type.transform);
          var transitionApi = transition.start({
            update: function update(v) {
              return value.update(v);
            },
            complete: complete
          });
          activeActions.set(key, transitionApi);
          activePoses.set(key, next);
        });
      });
    };

    if (nextPose && hasChildren) {
      if (exports.resolveProp(nextPose.beforeChildren, baseTransitionProps)) {
        return Promise.all(getParentAnimations()).then(function () {
          return Promise.all(getChildAnimations());
        });
      } else if (exports.resolveProp(nextPose.afterChildren, baseTransitionProps)) {
        return Promise.all(getChildAnimations()).then(function () {
          return Promise.all(getParentAnimations());
        });
      }
    }

    return Promise.all(getParentAnimations().concat(getChildAnimations()));
  };
};

exports.default = createPoseSetter;